<template>
    <modal name="cancelada" :scrollable="true" :height="'auto'" :clickToClose="false">
      <div class="container p-4">
          <div >
            <div class="text-center mb-4">
                <h3 class="with-lines">Detalle Importación</h3>
            </div>
              <div class="p-3">
                  <div class="row">
                    <label class="col-sm-2 col-form-label">Importación:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="Importacion" disabled>
                    </div>
                </div>
                  <div class="row">
                    <label class="col-sm-2 col-form-label">Estatus:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" value="Cancelada" disabled>
                    </div>
                </div>
                  <div class="row">
                    <label class="col-sm-2 col-form-label">Tipo:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="Tipo" disabled>
                    </div>
                </div>
                  <div class="row">
                    <label class="col-sm-3 col-form-label">Motivo de cancelación:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-9">
                        <input type="text" class="form-control diferentInput" v-model="Motivo" disabled>
                    </div>
                </div>
                  <div class="row">
                    <label class="col-sm-3 col-form-label">Fecha de importación:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-9">
                        <input type="text" class="form-control diferentInput" v-model="FechaI" disabled>
                    </div>
                </div>
                  <div class="row">
                    <label class="col-sm-3 col-form-label">Fecha de cancelación:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-9">
                        <input type="text" class="form-control diferentInput" v-model="FechaC" disabled>
                    </div>
                </div>
            </div>
              <div class="mt-4 text-center">
                  <button class="btn btn-primary col-4" @click="$modal.hide('cancelada');">Cerrar</button>
              </div>
          </div>
      </div>
      </modal> 
  </template>
  
  <script>
  export default {
    props: {
        Importacion: {
            type: String,
            required: true,
        },
        Tipo: {
            type: String,
            required: true,
        },
        Motivo: {
            type: String,
            required: true,
        },
        FechaI: {
            type: String,
            required: true,
        },
        FechaC: {
            type: String,
            required: true,
        },
    },
    data() {
    return {
      // Aquí podrías inicializar datos si los necesitas en este componente
    };
  },

    methods: {}
  }
  </script>
  
  <style>
  .diferentInput{
  border: none;
  border-bottom: 2px solid rgba(128, 128, 128, 0.568);
}
  .btn-primary{
      background-color: #1e536b !important;
      border-color: #1e536b !important;
      border-radius: 15px;
  }
  .with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
}
  </style>